import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message, Row, Col, Space, Image, Typography, Spin } from 'antd';
import axios from 'axios';

import CmbLingua from '../Combos/CmbLingua';
import Configurazione from '../Configurazione';
import sessionManager, { eVariableType } from '../SessionManager';
import { GetErrorMessage } from '../Utility';
import stringres from '../translations/stringres';

const { Title, Text } = Typography;

export default function LogIn() {
    const [form] = Form.useForm();

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [username, setUsername] = useState<string>(localStorage.getItem('username')?.toString() || '');
    const [password, setPassword] = useState<any>(localStorage.getItem('password'));
    const [datioperatore, setDatiOperatore] = useState<any>(sessionStorage.getItem('data'));

    const idSocieta: number = Configurazione().idsocieta;

    useEffect(() => {
        form.setFieldValue('username', username);
        form.setFieldValue('password', password);
        form.setFieldValue('idSocieta', idSocieta);
    }, [username, password, idSocieta, form]);

    useEffect(() => {
        if (datioperatore != null) {
            setUsername(datioperatore.Username);
            setPassword(datioperatore.Password);
        }
    }, [datioperatore]);

    const fetchData = async () => {
        sessionManager.clearSession();

        setIsLoading(true);

        setDatiOperatore(null);

        const data = {
            idSocieta: idSocieta,
            username: username,
            password: password,
        };

        try {
            const result = await axios.post(Configurazione().apiBaseUrl + 'Tabelle/LogIn', data);

            if (result != null && (result.data != null || result.data !== '') && result.data.token != null) {
                sessionManager.set(eVariableType.Token, result.headers['x-token']);
                sessionManager.set(eVariableType.Token, result.data.token);
                sessionManager.set(eVariableType.IDSocieta, idSocieta);
                sessionManager.set(eVariableType.IDOperatore, result.data.idOperatore);

                if (form.getFieldValue('remember')) {
                    localStorage.setItem('username', username);
                    localStorage.setItem('password', password);
                    localStorage.setItem('idSocieta', idSocieta.toString());
                } else {
                    localStorage.setItem('username', '');
                    localStorage.setItem('password', '');
                    localStorage.setItem('idSocieta', '');
                }

                navigate('/clienti');
            } else {
                message.error('No data available', 5);
            }
        } catch (error: any) {
            message.error(GetErrorMessage(error), 5);
        } finally {
            setIsLoading(false);
        }
    };

    const onFinish = () => {
        fetchData();
    };

    return (
        <div className="pnlx">
            <Spin spinning={isLoading}>
                <Row wrap>
                    <Col flex={'auto'} xs={24} md={8} span={8}>
                        <Form form={form} initialValues={{ remember: true }} onFinish={onFinish}>
                            <div className="pnllg">
                                <div style={{ textAlign: 'center', paddingTop: '5%' }}>
                                    <Image height={112} src="images/LogoIsodataBlu.png"></Image>
                                    <Title level={2}>ID di accesso MarbleR2</Title>
                                    <hr className="linea"></hr>
                                    <div
                                        style={{
                                            padding: '10px',
                                            margin: '10px',
                                            backgroundColor: '#EFFBC5',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Text>
                                            Accedi al tuo account MarbleR2 utilizzando il tuo ID di accesso e la
                                            password{' '}
                                        </Text>
                                    </div>
                                    <br></br>
                                    <Space style={{ width: '80%' }} direction="vertical" size={5}>
                                        <Text className="titolo">Inserisci i tuoi dati di accesso</Text>
                                        <Form.Item
                                            name="username"
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        stringres.t('inserireCampo') + ' ' + stringres.t('userName'),
                                                },
                                            ]}
                                        >
                                            <Input
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                                prefix={<UserOutlined />}
                                                size="large"
                                                placeholder="Username / e-Mail"
                                            ></Input>
                                        </Form.Item>
                                        <Form.Item
                                            name="password"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: stringres.t('inserireCampo') + ' ' + stringres.t('psw'),
                                                },
                                            ]}
                                        >
                                            <Input
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                prefix={<LockOutlined />}
                                                size="large"
                                                placeholder="Password"
                                                type="Password"
                                            ></Input>
                                        </Form.Item>
                                        <Form.Item name="remember" valuePropName="checked">
                                            <Checkbox style={{ width: '60%' }}>Salva accesso</Checkbox>
                                        </Form.Item>
                                    </Space>
                                    <hr className="linea"></hr>
                                    <Space size={5} style={{ width: '80%', marginTop: '15px' }} direction="vertical">
                                        <Button size="large" style={{ width: '60%' }} type="primary" htmlType="submit">
                                            Accedi
                                        </Button>
                                        <br></br>
                                        <CmbLingua width="60%"></CmbLingua>
                                    </Space>
                                    <div className="allineadxbottom">
                                        <Image height={25} src="images/LogoIsodataBlu.png"></Image>
                                        <Text className="testostandard" style={{ fontSize: 10 }}></Text>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </Col>
                    <Col flex={'auto'} xs={0} md={16} span={16}>
                        <div>
                            <div style={{ marginLeft: '8%', marginTop: '7%' }}>
                                <Image height={140} src="IconaMR2_rid.png" style={{ paddingRight: '40px' }}></Image>
                                <Typography.Text className="testotitolo">CRM - Marble</Typography.Text>
                                <Typography.Text className="testotitolo" style={{ color: '#523CBB' }}>
                                    R2
                                </Typography.Text>
                            </div>
                            <div style={{ marginLeft: '12%', marginTop: '10%' }}>
                                <Space direction="vertical" size={10}>
                                    <Text className="testoparagrafo">Il tuo spazio di lavoro su MarbleR2</Text>
                                    <Text className="testostandard">Potrai accedere alle sezioni:</Text>
                                    <Text className="testostandard"> - Gestione contatti</Text>
                                    <Text className="testostandard"> - Opportunità eventi ed allegati</Text>
                                    <Text className="testostandard"> - Gestione viaggi</Text>
                                </Space>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
}
